<mat-form-field class="w-100" appearance="outline">
    <mat-label>{{ label | translate }}</mat-label>

    <mat-select [formControlName]="fieldName" [required]="required" [disableOptionCentering]="true" (selectionChange)="onChange($event.value)">
        <mat-option *ngIf="!required"></mat-option>
        <mat-option *ngFor="let option of getDomain()" [value]="option.key">
            {{option.value}}
        </mat-option>
    </mat-select>

    <mat-error *ngIf="getFormControlField()?.hasError('required')">
        {{ 'data-table.validation.field-required' | translate }}
    </mat-error>
</mat-form-field>